import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from './strata_compatibility_checks';

Blockly.Blocks['strata_predictive_dashboard'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("Update climate projection dashboard");

        this.setPreviousStatement(true, 'strata_predictive_outputs');
        this.setNextStatement(true, getAllowedOutputs('strata_calculate_stress'));
        this.setColour('#53565a');
        this.setStyle("dashboards")
        this.setTooltip("");
        this.setHelpUrl("");
    },

}